import {isArrayEmpty, isNullOrUndefined} from "../../../services/Validator";
import BrevetLevelAsItem from "../../items/brevetScreen/BrevetLevelAsItem";
import BrevetLevelAsListVoid from "../../voids/brevetScreen/BrevetLevelAsListVoid";

export default function BrevetLevelAsList({displayedLevelAs, hasFilters, clearFilters}) {
    // Used in BrevetCoreContent to display list of displayed
    // brevet LevelAs

    // PROPERTIES
    if (isNullOrUndefined(displayedLevelAs))
        return null
    if (!isNullOrUndefined(displayedLevelAs) && isArrayEmpty(displayedLevelAs) && hasFilters)
        return <BrevetLevelAsListVoid clearFilters={clearFilters} />
    return (
        <div className={"animate-appearSlow w-full grow overflow-auto"}>
            {displayedLevelAs?.map((levelA, index) => (
                <BrevetLevelAsItem key={index}
                                   index={index}
                                   total={displayedLevelAs.length}
                                   levelA={levelA} />
            ))}
        </div>
    );
}